/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {
 DatePickerField,
 Model,
 RadioButtonField,
 Select2DropdownField,
 TextField,
} from 'helpers'
import {IFormField, IRejectionReason} from 'models/Common'
import {formatDateForDB} from 'utils/helper'
import moment from 'moment'
import {toast} from 'react-toastify'
import {updateOrderStatus} from 'utils/api/auth/orderManagementService'
import {fetchRejectionReasons} from 'utils/api/auth/commonService'
import {PhoneNoField} from 'helpers/ui-components/form/PhoneNoField'
import {OTPField} from 'helpers/ui-components/form/OTPField'

type IProps = {
 loggedInUserId: number | undefined
 actionDetails: IFormField | null
 setActionDetails: (newState: IFormField | null) => void
 setLoader: (newState: boolean) => void
 reloadTableData: () => void
}

const OrderActions = (props: IProps) => {
 const {t} = useTranslation()
 const [othersReasonId, setOthersReasonId] = useState('')
 const [showActionModel, setShowActionModel] =
  useState(false)
 const [rejection_reasonList, setRejectionReasonList] =
  useState<IRejectionReason[]>([])

 const paymentMode = [
  {
   id: 'CASH',
   value: t('common.modeOfPayment.cash'),
  },
  {
   id: 'CHEQUE',
   value: t('common.modeOfPayment.cheque'),
  },
  /* {
   id: 'UPI',
   value: t('common.modeOfPayment.upi'),
  },
  ,
  {
   id: 'Net Banking',
   value: t('common.modeOfPayment.netBanking'),
  }, */
 ]

 const popupHeader: IFormField = {
  CONFIRMED: t('orderManagement.acceptOrder'),
  SHIPPED: t('orderManagement.markDispatch'),
  REJECTED: t('orderManagement.resionForRejection'),
  CANCELLED: t('orderManagement.resionForCancellation'),
  DELIVERED: t('orderManagement.markDeliveryPopupHeader'),
  PAYMENT_CONFIRMED: t(
   'orderManagement.paymentConfirmation'
  ),
  FAILED: t('orderManagement.raiseDispute'),
 }

 const rejectionReason: IFormField = {
  REJECTED: 'so_rejection',
  CANCELLED: 'so_cancellation',
  FAILED: 'so_failed',
 }
 const formValues = {
  estimated_delivery_date: moment().toDate(),
  order_id: '',
  reason_id: '',
  retailer_name: '',
  rejection_reason: '',
  dispatch_date: moment().toDate(),
  payment_date: moment().toDate(),
  logistics_provider_phone_number: '',
  is_confirm: '',
  is_payment_done: '',
  payment_method: '',
  otp: '',
 }
 const {
  register,
  control,
  watch,
  setFocus,
  setValue,
  reset,
  handleSubmit,
  unregister,
  formState: {errors, isValid},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...formValues},
 })
 const getRejectionReasons = async () => {
  const reasonKey =
   rejectionReason?.[props.actionDetails?.status]
  if (reasonKey) {
   props.setLoader(true)
   const res: IRejectionReason[] | null =
    await fetchRejectionReasons(reasonKey)
   if (res) {
    const othersReasonId = res.find(
     (reason) => reason.reason === 'Others'
    )
    if (othersReasonId?.id)
     setOthersReasonId(othersReasonId.id.toString())
    setRejectionReasonList(res ?? [])
   }
   props.setLoader(false)
  }
 }

 const handleActionBtnClick = (
  orderId: number | null,
  status: string
 ) => {
  const payload = {
   order_id: orderId?.toString() ?? '',
   status,
   estimated_delivery_date: moment().toDate(),
   retailer_name: '',
   reason_id: '',
   rejection_reason: '',
   dispatch_date: moment().toDate(),
   payment_date: moment().toDate(),
   logistics_provider_phone_number: '',
   is_payment_done: '',
   payment_method: '',
   otp: '',
  }
  reset({...payload})
  if (props.actionDetails?.status === 'CONFIRMED') {
   unregister([
    'reason_id',
    'retailer_name',
    'rejection_reason',
    'dispatch_date',
    'payment_date',
    'logistics_provider_phone_number',
    'is_confirm',
    'is_payment_done',
    'otp',
    'payment_method',
   ])
  } else if (props.actionDetails?.status === 'SHIPPED') {
   unregister([
    'reason_id',
    'retailer_name',
    'rejection_reason',
    'payment_date',
    'estimated_delivery_date',
    'is_payment_done',
    'otp',
    'payment_method',
   ])
  } else if (props.actionDetails?.status === 'DELIVERED') {
   unregister([
    'reason_id',
    'retailer_name',
    'rejection_reason',
    'estimated_delivery_date',
    'dispatch_date',
    'payment_date',
    'logistics_provider_phone_number',
    'is_confirm',
   ])
  } else if (
   props.actionDetails?.status === 'PAYMENT_CONFIRMED'
  ) {
   unregister([
    'reason_id',
    'retailer_name',
    'rejection_reason',
    'estimated_delivery_date',
    'dispatch_date',
    'logistics_provider_phone_number',
    'is_confirm',
    'otp',
   ])
  } else if (props.actionDetails?.status === 'FAILED') {
   unregister([
    'estimated_delivery_date',
    'dispatch_date',
    'payment_date',
    'logistics_provider_phone_number',
    'is_payment_done',
    'payment_method',
    'otp',
   ])
   setValue(
    'retailer_name',
    props.actionDetails?.retailer_name
   )
  } else {
   unregister([
    'estimated_delivery_date',
    'dispatch_date',
    'payment_date',
    'retailer_name',
    'logistics_provider_phone_number',
    'is_confirm',
    'is_payment_done',
    'otp',
    'payment_method',
   ])
  }
 }

 const submitFormData = async (formData: IFormField) => {
  console.log('formData', formData)
  if (formData?.order_id) {
   props.setLoader(true)
   if (
    formData.status === 'DELIVERED' &&
    formData?.is_payment_done !== '1'
   ) {
    delete formData?.payment_method
   }

   if (formData.status === 'FAILED') {
    delete formData?.retailer_name
   }

   const payload = {
    ...formData,
    ...(formData?.estimated_delivery_date && {
     estimated_delivery_date: formatDateForDB(
      formData.estimated_delivery_date
     ),
    }),
    ...(formData?.dispatch_date && {
     dispatch_date: formatDateForDB(formData.dispatch_date),
    }),
    ...(formData?.payment_date &&
     formData.status === 'PAYMENT_CONFIRMED' && {
      payment_date: formatDateForDB(formData.payment_date),
      is_payment_clearance_request:
       formData.is_payment_done,
      status: '',
     }),
    ...(formData.status === 'DELIVERED' && {
     is_payment_done:
      formData?.is_payment_done === '1' ? true : false,
     otp: formData.otp.join(''),
    }),
   }
   if (formData.status === 'PAYMENT_CONFIRMED') {
    delete payload.status
    delete payload.is_payment_done
   }
   console.log(formData.status)
   const res = await updateOrderStatus(
    formData.order_id,
    payload
   )
   if (res) {
    toast.success(res)
    setShowActionModel(false)
    reset()
    props.setActionDetails(null)
    props.reloadTableData()
   }
   props.setLoader(false)
  } else {
   toast.error(t('errors.pleaseSelectOrder'))
  }
 }

 useEffect(() => {
  if (props.actionDetails) {
   handleActionBtnClick(
    props.actionDetails.orderId,
    props.actionDetails.status
   )
   void getRejectionReasons()
   setShowActionModel(true)
  }
 }, [props.actionDetails])

 useEffect(() => {
  if (!showActionModel) {
   reset()
   props.setActionDetails(null)
  }
 }, [showActionModel])

 return (
  <>
   <Model
    show={showActionModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     setShowActionModel(false)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {popupHeader?.[props.actionDetails?.status]}
      </p>
      <form
       method='POST'
       action=''
       onSubmit={handleSubmit(submitFormData)}
      >
       <div className='w-full mt-5 text-[#171B1F]'>
        {props.actionDetails?.status === 'CONFIRMED' ? (
         <DatePickerField
          disabled={false}
          label={t('orderManagement.tentativeDeliveryDate')}
          labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
          className={`font-normal !text-[#33393D] boxed-select2 relative block text-lg border-0  !rounded-l-lg !pl-0`}
          wrapperClassName='relative w-full'
          inputWrapperClassName='py-2 px-4'
          popperClassName='!z-[50]'
          required={true}
          id={`estimated_delivery_date`}
          name={`estimated_delivery_date`}
          control={control}
          rules={{
           validate: {
            required: (v: string) => {
             if (v === '')
              return `${t('helperText.plsSelect')} ${t(
               'orderManagement.tentativeDeliveryDate'
              )}`
            },
           },
          }}
          minDate={moment().toDate()}
          placeholder={t('common.dateFormat')}
          errors={errors}
          dateFormat='dd-MM-yyyy'
         />
        ) : props.actionDetails?.status === 'SHIPPED' ? (
         <>
          <DatePickerField
           disabled={false}
           label={t('orderManagement.dispatchDate')}
           labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
           className={`font-normal !text-[#33393D] boxed-select2 relative block text-lg border-0  !rounded-l-lg !pl-0`}
           wrapperClassName='relative w-full'
           inputWrapperClassName='py-2 px-4'
           popperClassName='!z-[50]'
           required={true}
           id={`dispatch_date`}
           name={`dispatch_date`}
           control={control}
           rules={{
            validate: {
             required: (v: string) => {
              if (v === '')
               return `${t('helperText.plsSelect')} ${t(
                'orderManagement.dispatchDate'
               )}`
             },
            },
           }}
           minDate={moment().toDate()}
           placeholder={t('common.dateFormat')}
           errors={errors}
           dateFormat='dd-MM-yyyy'
          />
          <PhoneNoField
           type='text'
           disabled={false}
           label={t('orderManagement.phoneNumber')}
           labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
           className='font-normal'
           wrapperClassName='relative w-full mt-5'
           required={true}
           countryCode='+91'
           helperText={t(
            'orderManagement.honeNumberHepler'
           )}
           id='logistics_provider_phone_number'
           name='logistics_provider_phone_number'
           placeholder={t(
            'orderManagement.enterPhoneNumber'
           )}
           register={register(
            'logistics_provider_phone_number',
            {
             validate: {
              regex: (v: string) => {
               if (v !== '' && !v?.match('^[6-9][0-9]{9}$'))
                return `${t(
                 'helperText.plsEnterValid'
                )} ${t('loginPage.mobileNo')}`
              },
              required: (v) => {
               if (v === '')
                return `${t('helperText.plsEnter')} ${t(
                 'loginPage.mobileNo'
                )}`
              },
             },
            }
           )}
           errors={errors}
          />
          <RadioButtonField
           label={''}
           required={true}
           type='checkbox'
           wrapperClassName={'mt-5'}
           containerClass='form-field-wrapper relative flex items-stretch rounded-lg border border-solid 
           border-[#FFF3C2] bg-[#FFFEEB] focus-within:border-[#000000] p-5'
           className='relative text-[16px] font-medium'
           listItemClassName='flex mb-4 !text-[#33393D] text-sm !font-normal'
           id={`is_confirm`}
           name={`is_confirm`}
           value='1'
           register={register(`is_confirm`, {
            validate: {
             required: (v: string) => {
              if (!v)
               return `${t('helperText.plsSelect')} ${t(
                'orderManagement.confirmText'
               )}`
             },
            },
           })}
           placeholder={''}
           data={[
            {
             id: '1',
             value: t('orderManagement.confirmText'),
            },
           ]}
           OptionValueKey='id'
           OptionLabelKey='value'
           errors={errors}
          />
         </>
        ) : ['PAYMENT_CONFIRMED', 'DELIVERED'].includes(
           props.actionDetails?.status
          ) ? (
         <>
          {props.actionDetails?.status === 'DELIVERED' && (
           <>
            <OTPField
             maxLength={1}
             label={t('orderManagement.otpLabel')}
             helperText={t('orderManagement.otpHelper')}
             required={true}
             labelClassName='text-[#4E83E4] text-xs font-medium mb-2'
             className='w-[60px] h-[50px] relative !py-3 text-center !px-4 rounded-lg border border-[#33393D] text-[#171B1F] !text-2xl !px-0 !font-medium block items-center'
             wrapperClassName='relative w-full'
             containerClass='!flex  gap-2 mt-2'
             register={register}
             validation={{
              validate: {
               regex: (v: string) => {
                if (v !== '' && !v?.match('^[0-9]{1}$'))
                 return ``
               },
               required: (v: string) => {
                if (v === '') return ``
               },
              },
             }}
             placeholder='_'
             type={'test'}
             name={'otp'}
             length={6}
             errorText={`${t('helperText.plsEnter')} ${t(
              'orderManagement.otpLabel'
             )}`}
             setFocus={setFocus}
            />
            <p className='text-[#171B1F] text-left font-bold text-2xl my-5'>
             {t('orderManagement.paymentConfirmation')}
            </p>
           </>
          )}
          <RadioButtonField
           label={t('orderManagement.wantToRecivePayment')}
           required={true}
           type='radio'
           labelClassName='text-[#4E83E4] text-xs font-medium'
           wrapperClassName={'mt-5'}
           className='relative text-[16px] font-medium invisible !w-[0]'
           listItemClassName={`pr-auto text-center justify-center flex rounded-lg border border-solid 
            border-[#E6EBF0] hover:border-[#4E83E4] hover:bg-[#F5FAFF] focus-within:border-[#000000] py-3 px-4 !text-[#4E83E4] text-base !font-semibold`}
           listItemActiveClassName='!border-[#4E83E4] !bg-[#F5FAFF]'
           listWrapperClass='grid gap-2 md:grid-cols-2'
           id={`is_payment_done`}
           name={`is_payment_done`}
           value={watch('is_payment_done')}
           register={register(`is_payment_done`, {
            validate: {
             required: (v: string) => {
              if (!v)
               return `${t('helperText.plsSelect')} ${t(
                'orderManagement.confirmText'
               )}`
             },
            },
           })}
           placeholder={''}
           data={[
            {
             id: '1',
             value: t('orderManagement.yes'),
            },
            ...(props.actionDetails?.status !==
            'PAYMENT_CONFIRMED'
             ? [
                {
                 id: '2',
                 value: t('orderManagement.no'),
                },
               ]
             : []),
           ]}
           OptionValueKey='id'
           OptionLabelKey='value'
           errors={errors}
          />
          {props.actionDetails?.status ===
           'PAYMENT_CONFIRMED' && (
           <DatePickerField
            disabled={false}
            label={t('orderManagement.paymentDate')}
            labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
            className={`font-normal !text-[#33393D] boxed-select2 relative block text-lg border-0  !rounded-l-lg !pl-0`}
            wrapperClassName='relative w-full mt-5'
            inputWrapperClassName='py-2 px-4'
            popperClassName='!z-[50]'
            required={true}
            id={`payment_date`}
            name={`payment_date`}
            control={control}
            rules={{
             validate: {
              required: (v: string) => {
               if (v === '')
                return `${t('helperText.plsSelect')} ${t(
                 'orderManagement.paymentDate'
                )}`
              },
             },
            }}
            maxDate={moment().toDate()}
            placeholder={t('common.dateFormat')}
            errors={errors}
            dateFormat='dd-MM-yyyy'
           />
          )}
          {watch('is_payment_done') === '1' && (
           <RadioButtonField
            label={t('orderManagement.selectModeOfPayment')}
            required={true}
            type='radio'
            labelClassName='text-[#4E83E4] text-xs font-medium'
            wrapperClassName={'mt-5'}
            className='relative text-[16px] font-medium invisible !w-[0]'
            listItemClassName={`text-center justify-center flex rounded-lg border border-solid 
            border-[#E6EBF0] hover:border-[#4E83E4] hover:bg-[#F5FAFF] focus-within:border-[#000000] py-3 px-4
            !text-[#4E83E4] !text-sm !font-semibold`}
            listItemActiveClassName='!border-[#4E83E4] !bg-[#F5FAFF]'
            listWrapperClass='grid gap-1 md:grid-cols-4'
            listLabelClassName={'!ml-0'}
            id={`payment_method`}
            name={`payment_method`}
            value={watch('payment_method')}
            register={register(`payment_method`, {
             validate: {
              required: (v: string) => {
               if (!v)
                return `${t('helperText.plsSelect')} ${t(
                 'orderManagement.modeOfPayment'
                )}`
              },
             },
            })}
            placeholder={''}
            data={paymentMode}
            OptionValueKey='id'
            OptionLabelKey='value'
            errors={errors}
           />
          )}
         </>
        ) : props.actionDetails?.status === 'FAILED' ? (
         <>
          <TextField
           type='text'
           label={t('orderManagement.retailerName')}
           labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
           className={`font-normal !text-[#33393D] boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
           wrapperClassName='relative w-full'
           inputWrapperClassName='pl-4 py-2 px-4 '
           required={false}
           disabled={true}
           id={`retailer_name`}
           name={`retailer_name`}
           register={register(`retailer_name`)}
           placeholder={`${t(
            'orderManagement.retailerName'
           )}`}
           errors={errors}
          />
          <TextField
           type='text'
           label={t('orderManagement.orderId')}
           labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
           className={`font-normal !text-[#33393D] boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
           wrapperClassName='relative w-full mt-4'
           inputWrapperClassName='pl-4 py-2 px-4 '
           required={false}
           disabled={true}
           id={`order_id`}
           name={`order_id`}
           register={register('order_id')}
           placeholder={`${t('orderManagement.orderId')}`}
           errors={errors}
          />
          <Select2DropdownField
           label={t('orderManagement.raiseDispute')}
           labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
           className={`boxed-select2  !text-[#33393D] !font-normal  relative block text-lg border-0  !rounded-l-lg`}
           wrapperClassName='relative w-full my-4'
           inputWrapperClassName='pl-4 py-2 px-4 '
           required={true}
           disabled={false}
           isClearable={false}
           isSearchable={true}
           control={control}
           customStyle={{
            transition: 'unset',
            boxShadow: 'unset',
            border: '0px',
            borderRadius: '0px',
            padding: '0px 0px 0px 0px',
            minHeight: 'auto',
           }}
           rules={{
            validate: {
             required: (v: string) => {
              if (v === '')
               return `${t('helperText.plsSelect')} ${t(
                'orderManagement.raiseDispute'
               )}`
             },
            },
           }}
           id={`reason_id`}
           name={`reason_id`}
           data={rejection_reasonList || []}
           OptionValueKey='id'
           OptionLabelKey='reason'
           placeholder={`${t('helperText.selectHere')}`}
           errors={errors}
          />
         </>
        ) : (
         <>
          <RadioButtonField
           label={''}
           required={true}
           type='radio'
           wrapperClassName={'max-w-[350px]'}
           className='relative text-[16px] font-medium'
           listItemClassName='flex mb-4 !text-[#33393D] !font-medium'
           id={`reason_id`}
           name={`reason_id`}
           register={register(`reason_id`, {
            validate: {
             required: (v: string) => {
              if (v === '')
               return `${t('helperText.plsSelect')} ${t(
                'orderManagement.resionForRejection'
               )}`
             },
            },
           })}
           placeholder={''}
           data={rejection_reasonList || []}
           OptionValueKey='id'
           OptionLabelKey='reason'
           errors={errors}
          />
          {watch('reason_id') == othersReasonId && (
           <TextField
            type='text'
            label={t('orderManagement.reason')}
            labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
            className={`font-normal !text-[#33393D] boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
            wrapperClassName='relative w-full pl-10'
            inputWrapperClassName='pl-4 py-2 px-4 '
            required={false}
            disabled={false}
            id={`rejection_reason`}
            name={`rejection_reason`}
            register={register(`rejection_reason`, {
             validate: {
              required: (v: string) => {
               if (v === '')
                return `${t('helperText.plsEnter')} ${t(
                 'orderManagement.reason'
                )}`
              },
             },
            })}
            placeholder={`${t('orderManagement.reason')}`}
            errors={errors}
           />
          )}
         </>
        )}
       </div>
       <div className='md:flex items-center justify-center mt-7'>
        <Button
         type={'submit'}
         disabled={!isValid}
         color='blue'
         className='disabled:text-white text-center w-full py-[9px] px-6 bg-[#4E83E4] 
                             !rounded-lg !text-base text-white font-semibold border-[#4E83E4]'
        >
         {t('orderManagement.confirm')}
        </Button>
       </div>
      </form>
      {props.actionDetails?.status === 'DELIVERED' && (
       <p className='text-[#666] font-normal text-base mt-5 text-center'>
        {t('orderManagement.facingProblems')}
        <button
         onClick={() => {
          props.setActionDetails({
           ...props.actionDetails,
           status: 'FAILED',
          })
         }}
         className='text-[#4E83E4] font-semibold pl-1'
        >
         {t('orderManagement.raiseDispute')}
        </button>
       </p>
      )}
     </div>
    </div>
   </Model>
  </>
 )
}

export default OrderActions
